// extracted by mini-css-extract-plugin
module.exports = {"starsOuter":"StarRating_starsOuter__2qaEI","starsInner":"StarRating_starsInner__25LUv"};